import { useSignal } from '@preact/signals'
import { clsx } from 'clsx'

import { OnboardingForm, ProfileForm } from './components'

const PROFILE_PAGE = 1
const OBOARDING_PAGE = 2

const Profile = () => {
	const currentPage = useSignal(1)

	const navigateToOnboardingPage = () => {
		currentPage.value = OBOARDING_PAGE
	}

	return (
		<div class='flex-1 '>
			<div
				class={`absolute inset-0 flex flex-1 items-center justify-center transition-transform duration-500 ${
					currentPage.value === PROFILE_PAGE
						? 'translate-x-0'
						: '-translate-x-full'
				}`}
			>
				<ProfileForm navigateToOnboardingPage={navigateToOnboardingPage} />
			</div>

			<div
				class={clsx(
					`absolute inset-0 flex flex-1 items-center justify-center transition-transform duration-500 ${
						currentPage.value === OBOARDING_PAGE
							? 'translate-x-0'
							: 'translate-x-full'
					}`
				)}
			>
				<OnboardingForm />
			</div>
		</div>
	)
}

export { Profile }
